import { useSelector } from 'react-redux'
import TeamSpiritView from './components/TeamSpiritView'
import useTeamSpiritViewModel from './hooks/useTeamSpiritViewModel'
import { isU21NationalTeam } from '../../services/security'

const TeamSpiritImpact = ({ nationalTeamId = 3023, isU21 = false }) => {
  const user = useSelector(state => state.user)
  const activeNationalTeamId = Number(user?.activeNationalTeam)
  const matchingStaff = Array.isArray(user?.staff)
    ? user.staff.filter(staff => {
        const staffIsU21 = isU21NationalTeam(staff?.nationalTeamName)
        return staffIsU21 === isU21
      })
    : []
  const activeU21TeamId = Array.isArray(user?.nationalTeamPairs)
    ? Number(
        user.nationalTeamPairs.find(
          pair => Number(pair?.nationalTeamId) === activeNationalTeamId
        )?.u21TeamId
      )
    : null
  const activeStaff = matchingStaff.find(staff =>
    Number(staff?.nationalTeamId) ===
    (isU21 ? activeU21TeamId : activeNationalTeamId)
  )
  const viewNationalTeamId = Number(
    activeStaff?.nationalTeamId || nationalTeamId
  )

  const model = useTeamSpiritViewModel({
    user,
    language: user?.language || 'fi',
    oauthToken: user?.oauth_token || null,
    nationalTeamId: viewNationalTeamId,
    isU21,
  })

  return <TeamSpiritView model={model} />
}

export default TeamSpiritImpact
